import io from 'socket.io-client';
import { queryClient, teachurKeys } from '@teachur/http-client';

let socketInstance: SocketIOClient.Socket | null = null;

export const getSocketInstance = (): SocketIOClient.Socket | null => {
  return socketInstance;
};

export const createSocketInstance = (): SocketIOClient.Socket | null => {
  const token = localStorage.getItem('accessToken');

  if (!token) {
    return null;
  }

  if (socketInstance) {
    socketInstance.disconnect();
    socketInstance = null;
  }

  const socketUrl = import.meta.env.VITE_SOCKETS_URL || 'http://localhost:3000';

  socketInstance = io(socketUrl, {
    path: '/socket.io',
    reconnectionAttempts: 3,
    reconnectionDelay: 1000,
    query: {
      token,
    },
    timeout: 20000,
    transports: ['websocket'],
    autoConnect: false,
  });

  return socketInstance;
};

const connectToSockets = () => {
  let socket = getSocketInstance();

  if (!socket) {
    socket = createSocketInstance();
  }

  if (!socket) {
    return false;
  }

  socket.off('newNotification');

  socket.on('newNotification', () => {
    queryClient.invalidateQueries({ queryKey: teachurKeys.notifications.list() });
  });

  if (!socket.connected) {
    socket.connect();
  }
};

export default connectToSockets;
